import React, {useContext} from "react";

import { ConfigContext } from "../Config/ConfigContext";
import FormInput from "../form/form-input";
import http from "../utils/http";
import useForm from "../hooks/useForm";

import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    InputLabel,
    List,
    ListItem,
    MenuItem,
    Select,
    Stack,
    Switch,
    Typography,
} from "@mui/material";


const onLoad = async ({
    values
}) => {
    const tenant = await http.get({}, `${values.config.uri.base}/tenant/${values.tenantId}`);
    return {
        ...values,
        members: tenant.members,
    };
}

const inviteMember = async ({
    config,
    email,
    tenantId,
    onChangeBulk,
}) => {
    onChangeBulk({
        errored: false,
        error: "",
    });

    const inviteResult = await http.get({}, `${config.uri.base}/tenant/invite/${tenantId}/${email}`);

    if (inviteResult.errored) {
        console.dir(inviteResult)

        if(typeof inviteResult.error === 'object') inviteResult.error = JSON.stringify(inviteResult.error);

        onChangeBulk({
            errored: true,
            error: inviteResult.error,
        });

        return
    }

    onChangeBulk({
        members: inviteResult.members
    });
};

export default function Members(props) {
    const {config} = useContext(ConfigContext)

    const {
        state,
        onChange,
        onChangeBulk
    } = useForm({
        debug: true,
        initialState: {
            members: [],
            config,
            tenantId: props.tenantId,
            error:"",
            errored:false
        },
        onLoad
    });

    return (
        <Box>
            {state.values.errored && (
                <Stack direction="row" alignItems={"baseline"} justifyContent={'space-between'}>
                    <Typography sx={{color: "red"}}>Error! {state.values.error}</Typography>
                </Stack>
            )}
            <Stack direction="row" alignItems={"baseline"} justifyContent={'space-between'}>
                <FormInput
                    path='inviteEmail'
                    value={state.values.inviteEmail}
                    error={state.errors.inviteEmail}
                    onChange={onChange}
                />
                <Button
                    onClick={async()=> { 
                        await inviteMember({
                            onChangeBulk,
                            config,
                            email: state.values.inviteEmail,
                            tenantId: props.tenantId,
                        });
                    }}
                >Invite</Button>
            </Stack>
            <List sx={{width: '500px'}}>
                {state.values.members.map((x, index) => (
                    <ListItem 
                        key={index + x.email + x.userId} 
                        sx={{
                            justifyContent: 'space-between',
                            paddingLeft: 0,
                            paddingRight: 0,
                        }}
                    >
                        <Box sx={{width: '50%'}}>
                            <Typography>{x.email}</Typography>
                        </Box>
                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Role</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                path={`members[${index}].role`}
                                value={x.role}
                                label="Role"
                                onChange={async (event) => {
                                    await http.post({
                                        role: event.target.value
                                    }, `${config.uri.base}/tenant/user/${props.tenantId}/${x.userId}`);
                                    onChange(event.target.value, `members[${index}].role`);
                                }}
                            >
                                <MenuItem value={'Admin'}>Admin</MenuItem>
                                <MenuItem value={'Member'}>Member</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControlLabel control={
                            <Switch 
                                path={`members[${index}].active`}
                                onChange={async (event) => {
                                    const isChecked = event.target.checked;
                                    console.log("isChecked", isChecked);
                                    await http.post({
                                        active: isChecked
                                    }, `${config.uri.base}/tenant/user/${props.tenantId}/${x.userId}`);
                                    onChange(isChecked, `members[${index}].active`);
                                }} checked={x.active} />} label="Active" />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}
